
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const completeAction = async (actionId) => {
   
  
    const response = await authenticatedFetch(`${config.API_BASE_URL}/actions/${actionId}?completeAction=1`, {
        method: 'PUT',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });
      
      if (response.ok) {
        const responseData = await response.json();
            return responseData; 
      } else {
        throw new Error(`Error completeing action`);
      }
  
  };